import React from "react";
import Helmet from "react-helmet";
import styled from "styled-components";

import { graphql } from 'gatsby';
import SiteHeader from '../components/Layout/Header';
import config from "../templates/site-config";
// import { BrowserRouter, Switch } from 'react-router-dom';
import { compile, Browser, detach, select, Animation, selectAll, closest, Ajax, createElement } from '@syncfusion/ej2-base';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { AutoCompleteComponent, DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { SidebarComponent } from '@syncfusion/ej2-react-navigations';
import { Tooltip } from '@syncfusion/ej2-popups';
import { TreeView, Accordion, Tab } from '@syncfusion/ej2-navigations';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import { navigate } from "../../node_modules/gatsby-link/index";
import Layout from "../components/layout";

var gitBlazorMap = require('../../githubMapper.json');
var gitDocMap = require('../../gitDocMapper.json');

var setInt;
var routes = [];
var titles = [];
var tData;
var aData;
var tMapper;
var searchData = [];
var feedback;
var feedBackDownResponse;
var feedDlgInit = true;
var rTocInit = true;
var gcseInit = true;

var searchFields = { groupBy: 'component', value: 'title' };

var prefix = config.pathPrefix;
var isApi = config.isApi;
var isMobile = false;
var demosLink = '';

var platformMapper = {
  'JavaScript': 'essential-js2',
  'JavaScript (ES5)': 'essential-js2',
  'Angular': 'angular-js2',
  'React': 'react-js2',
  'Vue': 'vue',
  'ASP.NET Core': 'aspnetcore-js2',
  'ASP.NET MVC': 'aspnetmvc-js2',
  'Blazor': ''
};

var demosMapper = {
  'JavaScript': 'https://ej2.syncfusion.com/demos',
  'JavaScript (ES5)': 'https://ej2.syncfusion.com/javascript/demos',
  'Angular': 'https://ej2.syncfusion.com/angular/demos',
  'React': 'https://ej2.syncfusion.com/react/demos',
  'Vue': 'https://ej2.syncfusion.com/vue/demos',
  'ASP.NET Core': 'https://ej2.syncfusion.com/aspnetcore/',
  'ASP.NET MVC': 'https://ej2.syncfusion.com/aspnetmvc/',
  'Blazor': 'https://blazor.syncfusion.com/demos/'
};

var aspApiMapper = {
  'ASP.NET Core': 'https://help.syncfusion.com/cr/aspnetcore-js2/',
  'ASP.NET MVC': 'https://help.syncfusion.com/cr/aspnetmvc-js2/',
  'Blazor': 'https://help.syncfusion.com/cr/blazor/'
};

var githubMapper = {
  'Blazor': 'https://github.com/syncfusion/blazor-docs/tree/master/src/',
  'JavaScript': 'https://github.com/syncfusion/ej2-javascript-docs/tree/master/src/',
  'JavaScript (ES5)': 'https://github.com/syncfusion/ej2-javascript-docs/tree/master/src/',
  'React': 'https://github.com/syncfusion/ej2-React-docs/tree/master/src/',
  'Angular': 'https://github.com/syncfusion/ej2-Angular-docs/tree/master/src/',
  'Vue': 'https://github.com/syncfusion/ej2-Vue-docs/tree/master/src/',
  'ASP.NET Core': 'https://github.com/syncfusion/ej2-aspnetcore-docs/tree/master/src/',
  'ASP.NET MVC': 'https://github.com/syncfusion/ej2-aspnetmvc-docs/tree/master/src/'
};

var ignoreApiSelect = ['base', 'angular-base', 'check-box', 'compression', 'data', 'excel-export', 'file-utils', 'pdf-export'];

var aspRegex = /ASP.NET Core|ASP.NET MVC|Blazor/;
var urlCheckRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/;
var noteCheckRegex = /<blockquote>\n+(<p>(Note|Warning|Information|Error|Tips)[\s]*:.+)+\n+<\/blockquote>/g;
var codeBlockRegex = /{%( |)codeBlock [^\0]*?{%( |)endcodeBlock( |)%}/g;
var isAspDocs = false;
var plat = '';

var uuid = 0;
var today = null;

// This class should not be used for listing posts, but for chapter based Docs. See PostListing for that.
// You'll also need to add your chapters to siteConfig

var isNotIE = true;

if (typeof window !== 'undefined') {
  isNotIE = !Browser.isIE;
}

export default class LayoutTemplate extends React.Component {

  search;
  feedBackDialog;
  emailCheckBox;
  leftSideBar;
  rightSideBar;
  dropObj;
  getRouteIndex(path) {
    return routes.searchArray(path);
  }

  filterData = [
    {
        dropName: 'All', dropId: '1'
    },
    {
      dropName: 'New Features', dropId: '2'
    },
    {
      dropName: 'Bug Fixes', dropId: '3'
    },
    {
      dropName: 'Breaking Changes', dropId: '4'
    },
    {
      dropName: 'Deprecated', dropId: '5'
    }
];

dropField = { value: 'dropId', text: 'dropName' };

index = 0;

constructor(props) {
  super(props);
  this.onFilterReleaseNotes = this.onFilterReleaseNotes.bind(this);
  this.onFilterCreated = this.onFilterCreated.bind(this);
    // super(...arguments);
    this.timeOutDelay = 600;
    this.cusPosition = { X: 'Right', Y: 'Bottom' };
    this.template = '<div class="e-toast-template"><img class="e-toast-icon e-toast-image toast-img-cnt" src="${image.url}" alt="Blazor E-Book poster" />'+ 
    '<div class="e-toast-message"><div class="e-toast-title toast-title-cnt">${from}</div>'
    +'<div class="e-toast-content toast-cnt">${subject}</div></div><div id = "toast-close"class="toast-content-close toast-close-btn"><span id="close-toast"></span></div>'
    +'<div class="popup-button-section btnlink" style="background-color:#9E25FF"><a id="popup-button" class="btn__text" href="https://www.syncfusion.com/ebooks/blazor-succinctly?utm_source=syncfusion_doc&utm_medium=textad&utm_campaign=syncfusion_blazorebsucc_textadcy20">Get your free ebook</a></div>';
    this.toastData = [
      { from: ' Blazor Ebook', subject: 'A quick guide to getting started with learning and improving your skills using Blazor technology.', image: { url: 'https://cdn.syncfusion.com/blazor/toaster.png' }, }
    ];
    this.toastFlag = 0;
  }

  cardTemplateFn(data) {
    return compile(this.template.trim())(data);
  }

  toastObjEmailCreate() {
    setTimeout(function () {
      this.toastObjEmail.show({ template: this.cardTemplateFn(this.toastData[this.toastFlag])[0].outerHTML });
    }.bind(this));
    if (localStorage.getItem("toast") === 'disable') {
      var toastele = select('#toast_custom');
      toastele.classList.add('doc-hide');
    }
  }

  closetoast() {
    localStorage.setItem("toast", "disable");
    var toastele = select('#toast_custom');
    toastele.classList.add('doc-hide');
  }

  toastObj() {
    var toastclosebtn = document.getElementById('toast-close');
    toastclosebtn.addEventListener('click', (e) => {
      localStorage.setItem("toast", "disable");
    var toastele = select('#toast_custom');
    toastele.classList.add('doc-hide');
    });
    var ebook = document.getElementById('popup-button')
    ebook.addEventListener('click', (e) => {
      localStorage.setItem("toast", "disable");
    var toastele = select('#toast_custom');
    toastele.classList.add('doc-hide');
    });
  }

  onFilterCreated() {
    if (this.props.pageContext.isReleaseNotes) {
      var h2Tags = document.getElementsByTagName('h2');
      var hidden;
      var rtoc = [];
      if (document.getElementById('doc-right-toc')) {
       rtoc = document.getElementById('doc-right-toc').children[1].children;   
      }
      for (var i = 0; i < h2Tags.length; i++) {
        var node = h2Tags[i];
        var temp = node;
        while (node) {
          temp = temp.nextElementSibling || '';
          if (temp.tagName === 'H2') {
            node.classList.add('doc-hide');
            hidden = node.innerText;
          }
          break;
        }
      }
      for (var j = 0; j < rtoc.length; j++) {
        if (rtoc[j].innerText === hidden) {
          rtoc[j].classList.add('doc-hide');
        }
      }
      var searchStr = window.location.search;
      if (searchStr) {
        searchStr = searchStr.split('?type=');
      } else {
        var path = window.location.href;
        window.history.pushState({}, null, path+'?type=all')
      }
      if (searchStr[1] === 'new-features') {
        this.dropObj.value = '2';
      } else if (searchStr[1] === 'bug-fixes') {
        this.dropObj.value = '3';
      } else if (searchStr[1] === 'breaking-changes') {
        this.dropObj.value = '4';
      }else if (searchStr[1] === 'deprecated') {
        this.dropObj.value = '5';
      } else {
        this.dropObj.value = '1';
      }
    }
  }


//function for filter release notes
  onFilterReleaseNotes() {
    var dropClass, dropHash;
    var removeAlert = document.getElementsByClassName('alert');
    if (removeAlert.length !== 0) {
      removeAlert[0].parentElement.removeChild(removeAlert[0]);
    }
    var h2Tags = document.getElementsByTagName('h2');
    if (this.dropObj.text === 'New Features') {
      dropClass = 'doc-new-features';
      dropHash = 'new-features';
    } else if (this.dropObj.text === 'Bug Fixes') {
      dropClass = 'doc-bug-fixes';
      dropHash = 'bug-fixes';
    } else if (this.dropObj.text === 'Breaking Changes') {
      dropClass = 'doc-breaking-changes';
      dropHash = 'breaking-changes';
    } else if (this.dropObj.text === 'Deprecated') {
      dropClass = 'doc-deprecated';
      dropHash = 'deprecated';
    } else {
      dropClass = 'all';
      dropHash = 'all';
    }
    var arr = [], flag1 = 0;
    for (var i = 0; i < h2Tags.length; i++) {
      var node = h2Tags[i];
      var temp = node;
      h2Tags[i].classList.remove('doc-hide');
      var flag = 0;
      while (node) {
        temp = temp.nextElementSibling || '';
        if (temp === null || temp.tagName === 'H2' || temp === '') {
          break;
        }
        if (temp.classList.contains('doc-badge-wrapper')) {
          var node1 = temp;
          var temp1 = node1;
          while (node1) {
            temp1 = temp1.nextElementSibling || '';
            if (temp1 === '' || temp1.classList.contains('doc-badge-wrapper') || temp1.tagName === 'H2') {
              break;
            }
            temp = temp.nextElementSibling || '';
            if (dropClass === 'all') {
              node1.classList.remove('doc-hide');
              temp.classList.remove('doc-hide');
            } else if (!node1.classList.contains(dropClass)) {
              temp.classList.add('doc-hide');
              node1.classList.add('doc-hide');
            } else {
              flag1 = 1;
              node1.classList.remove('doc-hide');
              temp.classList.remove('doc-hide');
            }
          }
        }
        if (!temp.classList.contains('doc-hide')) {
          flag = 1;
        }
      }
      if (flag === 1) {
        arr.push(h2Tags[i].innerText);
      } else {
        h2Tags[i].classList.add('doc-hide');
      }
    }
    if (flag1 === 0 && dropClass !== 'all') {
      var mdCnt = document.getElementById('md-cnt')
      var div = document.createElement('DIV');
      div.innerText = `No ${dropHash} for this product in this version.`;
      div.classList.add('alert');
      mdCnt.appendChild(div);
    }
    var rightToc = [];
    if (document.getElementById('doc-right-toc')) {
        rightToc = document.getElementById('doc-right-toc').children[1].children;   
    }
    for (var i = 0; i < rightToc.length; i++) {
      if (arr.indexOf(rightToc[i].innerText) !== -1) {
        rightToc[i].classList.remove('doc-hide');
      } else {
        rightToc[i].classList.add('doc-hide');
      }
    }
    var path = window.location.href;
    if (!path.includes('?type=' + dropHash)) {
      path = path.includes('?type=') ? path.replace(/\?type=.+/, '?type=' + dropHash) : path + '?type=' + dropHash;
      window.history.pushState({}, null, path);
    }
  }

  setNavContent() {
    var pIndex = this.getRouteIndex(this.getPathName());
    var fSample = pIndex === 0;
    var lSample = routes.length - pIndex === 1;
    var prevEle = document.getElementsByClassName('nav-prev-text')[0];
    var nextEle = document.getElementsByClassName('nav-next-text')[0];
    var prevCont = fSample ? titles[pIndex] : titles[--pIndex];
    var prevLink = routes[pIndex];
    var overviewBool = prevCont === undefined;
    var nextCont = lSample ? titles[pIndex] : titles[pIndex + (fSample ? 1 : 2)];
    var nextLink = lSample ? routes[pIndex] : routes[pIndex + (fSample ? 1 : 2)];
    if (isMobile) {
      prevCont = this.getMobileNavContent(prevCont);
      nextCont = this.getMobileNavContent(nextCont);
    }
    var pathPrefix = (prefix === '/') ? '' : prefix;
    select('#prev-link').href = (pathPrefix + prevLink) || '';
    select('#next-link').href = (pathPrefix + nextLink) || '';
    prevEle.innerText = prevCont;
    nextEle.innerText = nextCont;
    prevEle.parentElement.classList[fSample || overviewBool ? 'add' : 'remove']('doc-hide');
    nextEle.parentElement.classList[lSample ? 'add' : 'remove']('doc-hide');
  }

  getMobileNavContent(content) {
    if (content.indexOf('/') !== -1) {
      content = content.split('/')[1].trim();
    }
    return content;
  }

  getPathName() {
    var pathName = '';
    if (window) {
      pathName = window.location.pathname;
      if (prefix !== '/') {
        pathName = window.location.pathname.replace(prefix, '');
      }
    }
    return pathName;
  }

  expandedNode(path) {
    var expandTreeData = [];
    var pathArray = path.split('/');
    var comp = pathArray[1];
    var accData = aData;
    var accIndex = tMapper[comp];
    var treeData = tData[accIndex];
    var accordionIndex;
    for (var accor of accData) {
      if (accor.data && accIndex && accor.data === accIndex) {
        accordionIndex = accData.indexOf(accor);
      }
    }
    if (treeData) {
      for (var tmData of treeData) {
        tmData.expanded = tmData.id === comp;
        var tempExpanded = false;
        if (tmData.child && tmData.child.length) {
          var tChild = [];
          for (var tmChild of tmData.child) {
            tmChild.expanded = tmChild.id === path;
            if (tmChild.expanded) {
              tempExpanded = true;
            }
            tChild.push(tmChild);
          }
          tmData.child = tChild;
        }
        if (tempExpanded) {
          tmData.expanded = true;
        }
        expandTreeData.push(tmData);
      }
      tData[accIndex] = expandTreeData;
    }
    return accordionIndex;
  }

  expandAccordion(index) {
    var tocAccordion = document.getElementById('toc').ej2_instances[0];
    if (index || index === 0) {
      tocAccordion.expandItem(true, index);
    }
    tocAccordion.animation = { expand: { effect: 'SlideDown', duration: 400, easing: 'linear' }, collapse: { effect: 'SlideUp', duration: 400, easing: 'linear' } };
  }

  renderBreadCrumb() {
    var breadCrumbData = document.getElementById('bread-crumb-data').getAttribute('data');
    var bread = breadCrumbData.split('/');
    var indexRegex = /overview/i;
    if (!indexRegex.test(bread[bread.length - 1]) && ((breadCrumbData[0] !== '/') || (breadCrumbData.split('/').length === 2))) {
      var subDir = bread.length === 3;
      var lastBread = subDir ? bread[2] : bread[1];
      var breadCrumbElem = `<a class="doc-icons icon-home_icon" href="${this.props.pageContext.isReleaseNotes ? prefix + '/index/' : prefix}"></a>${breadCrumbData[0] === '/' ? '' : ' '} <a class="doc-bread-nav" href="${subDir ? '../../' : '../'}">${bread[0] ? '/ ' + bread[0] : ''}</a>${subDir ? ' / ' + bread[1] : ''}${lastBread ? ` / ${lastBread}` : ''}`;
      document.getElementById('doc-bread-crumb').innerHTML = breadCrumbElem;
      var breadDirElem = document.querySelector('.doc-bread-nav');
      if (breadDirElem) {
        breadDirElem.onclick = function (e) {
          e.preventDefault();
          var href = window.location.href;
          href = href.split('/');
          href.pop();
          if (subDir) {
            href.pop();
          }
          window.location.href = href.join('/');
        }
      }
    }
    detach(select('#bread-crumb-data'));
  }

  componentDidMount() {
    var title = window.toc.titles;
    var route = window.toc.path;
    routes = [];
    titles = [];
    for (var i = 0; i < route.length; i++) {
      if (!urlCheckRegex.test(route[i])) {
        routes.push(route[i]);
        titles.push(title[i]);
      }
    }
    tData = window.toc.treeData;
    aData = window.toc.accData;
    tMapper = window.toc.treeMapper;
    this.search.dataSource = window.toc.searchData;

    isMobile = window.matchMedia('(max-width:480px)').matches;

    window.gcseSearch = function () {
      select('#doc-body-cont').classList.add('gcse-search');
      select('#doc-search-result').classList.remove('doc-hide');
      select('#scroll-top').style.display = "none";
      var tocActive = select('.e-toc-active');
      if (tocActive) {
        tocActive.classList.remove('e-toc-active');
      }
    };
    renderToc();
    renderTab();
    createCustomSearch(this.props.pageContext.gcse);
    this.expandAccordion(this.expandedNode(this.getPathName()));
    this.setNavContent();
    this.rightTocSelect();
    this.renderBreadCrumb();
    this.selectedToc();
    this.configureHamburger();
    this.configureRightSideBar();
    this.configureMobileSearch();
    if (plat === 'JavaScript (ES5)') {
      var gitEditBtn = window.document.getElementById('editme');
      gitEditBtn.classList.add('doc-hide');  
    }
    if (plat !== 'Blazor' || this.props.pageContext.isReleaseNotes) {
      var toastele = select('#toast_custom');
      toastele.classList.add('doc-hide');
      var dropEle = select('#version-support');
      if (dropEle){
        dropEle.classList.add('doc-hide');   
      }
      var loadingIcon = select('#doc-overlay')
      if(loadingIcon){
       loadingIcon.classList.add('doc-hide');   
      }
    } 
    if (this.props.pageContext.isReleaseNotes) {
      var releaseFilter = select('#is-release');
      releaseFilter.classList.remove('doc-hide');
      releaseFilter.classList.add('filter-drop');
      var gitEditBtn = window.document.getElementById('editme');
      gitEditBtn.classList.add('doc-hide');
      document.getElementsByClassName('doc-header-links')[0].style.width = '326px';
      var updateGuideBtn = window.document.getElementById('upgrade-guide');
      updateGuideBtn.classList.add('doc-hide');
    }
    select('.doc-toc-search-icon').addEventListener('click', () => {
      var leftTocSearch = select('#auto-complete');
      if (leftTocSearch && leftTocSearch.value && leftTocSearch.ej2_instances) {
        leftTocSearch.ej2_instances[0].renderPopup();
      }
    });

    select('#editme').addEventListener('click', (event) => {
      event.currentTarget.classList.add('doc-edit-me-visited');
      var path = (window.location.href).replace(/\?no-cache.+/,'').split('documentation/')[1].split('/');
      var gitPath = githubMapper[plat];
      var gitMap = plat === 'Blazor' ? gitBlazorMap : gitDocMap;
      var editPath; 
      if(path.length === 2){
        editPath = gitPath+'common/'+path[0]+'.md';
      } else if(path.length === 3){
        editPath = gitPath+gitMap[path[0]]+'/'+path[0]+'/'+path[1]+'.md';
      } else {
        editPath = gitPath+gitMap[path[0]]+'/'+path[0]+'/'+path[1]+'/'+path[2]+'.md';
      }
      window.open(
        editPath,
        '_blank'
      );
    });

    var copyclips = document.getElementsByClassName('e-icons copycode');
    for(var i = 0; i < copyclips.length; i++) {
      copyclips[i].addEventListener('click', (event) => {
        event.currentTarget.children[0].classList.add('copytooltiptextvisit');
        setTimeout(() => {
            var copyclipsvisit = document.getElementsByClassName('copytooltiptextvisit');
            for(var i = 0; i < copyclipsvisit.length; i++) {
              copyclipsvisit[i].classList.remove('copytooltiptextvisit');
            }
        }, 1200);
      });
    }

    if (isMobile) {
      select('#md-content').addEventListener('click', this.docClick);
      select('#doc-footer').addEventListener('click', this.docClick);
      select('#doc-search-result').classList.remove('doc-hide');
    }

    if (plat === 'React') {
      ((window.location.href.indexOf('?type=tsx')) !== -1) ? select('#md-content').classList.add('hide-jsx') : select('#md-content').classList.add('hide-tsx');
    }

    if (!window.location.hash.length) {
      document.getElementById('md-content').scrollTop = 0;
    }
    if (isNotIE) {
      feedback = select('#footer-feedback');
      feedBackDownResponse = select('.feedback-down-response');
    }
    this.leftSideBar.mediaQuery = window.matchMedia('(min-width: 765px)');
    this.setHeaderClick();
    this.getUuid();
    setTimeout(() => {
      this.ScrollToc();
      // this.googleTagMapper();
      if (window.location.hash) {
        select(window.location.hash).click();
      }
      this.removeOverlay();
    }, 300);
    var closeBtn = createElement('div', { className: 'search-content-close', id: 'close-search-content', innerHTML: '<span id="close-search"></span>' });
      select('#doc-search-result').appendChild(closeBtn);
      closeBtn.addEventListener('click', this.closeSearchResult);
    var btn = createElement('button', { className: 'back-to-top', id: 'scroll-top', innerHTML: '<span id="icon-move-top"></span>' });
    btn.addEventListener('click',(e) => {
      select('#md-content').scrollTop = 0;
    });
    select('.doc-body-content').appendChild(btn);
    btn.style.display = "none";
    select('#md-content').onscroll = () => {
      if (select('#md-content').scrollTop > 20) {
        btn.style.display = "block";
      } else {
        btn.style.display = "none";
      }
    };
    window.onkeyup = (e) => {
      if (e.ctrlKey && e.which === 36) {
        select('#md-content').scrollTop = 0;
      } else if (e.ctrlKey && e.which === 35) {
        select('#md-content').scrollTo(0, select('#md-content').scrollHeight);
      } else if (e.keyCode === 27 && select('#doc-body-cont').classList.contains('gcse-search')) {
        this.closeSearchResult();
      }
    };
    //api link opening new window support
    var apilnk = document.getElementsByClassName('language-text');
    for(var api = 0; api < apilnk.length; api++){
      if(apilnk[api] && apilnk[api].parentElement.tagName === 'A') {
        apilnk[api].parentElement.target = '_blank';
      }
    }
  }

  getUuid() {
    if (getCookie('_uid') !== '') {
      uuid = getCookie('_uid');
    } else {
      today = new Date();
      var loadTimeOffset = today.getTimezoneOffset() * 60000;
      var estTimeOffset = ESTTimeOffset();
      var timeUTC = today.getTime() + loadTimeOffset;
      var timeEST = new Date(timeUTC + estTimeOffset) / 1;
      uuid = Math.floor(Math.random() * 1000) + 1 + timeEST.toString();
      createCookie('_uid', uuid);
    }
  }

  removeOverlay() {
    var docOverlay = select('#doc-overlay');
    if (docOverlay) {
      docOverlay.classList.add('doc-hide');
    }
  }

  docClick() {
    select('#doc-left-sidebar').ej2_instances[0].hide();
    select('#doc-mobile-right-toc').ej2_instances[0].hide();
    select('#doc-mobile-toc').classList.remove('right-toc-active');
    select('#doc-mobile-search').classList.remove('mobile-search-active');
    select('#md-content').classList.remove('mobile-search-enabled');
    select('#doc-mobile-content-search').classList.add('doc-hide');
  }

  setHeaderClick() {
    var headTags = selectAll('h1, h2, h3, h4', select('#md-cnt'));
    for (var head of headTags) {
      head.addEventListener('click', (e) => {
        var ele = select('a', e.srcElement) || select('a', e.srcElement.parentElement);
        ele.click();
      })
    }
  }

  configureHamburger() {
    select('.doc-hamburger-icon').addEventListener('click', () => {
      this.closeRightSideBar();
      this.leftSideBar.toggle();
      this.toggleMobileSearch(false);
    });
  }

  configureRightSideBar() {
    if (!select('.doc-no-right-toc')) {
      select('#doc-mobile-right-toc').classList.remove('doc-hide');
      select('#doc-mobile-toc').addEventListener('click', () => {
        if (rTocInit) {
          select('#doc-mobile-right-toc').classList.remove('doc-no-width');
          rTocInit = false;
        }
        select('#doc-mobile-toc').classList[this.rightSideBar.isOpen ? 'remove' : 'add']('right-toc-active');
        this.leftSideBar.hide();
        this.rightSideBar.toggle();
        this.toggleMobileSearch(false);
      });
    }
  }

  configureMobileSearch() {
    select('#doc-mobile-search').addEventListener('click', () => {
      var mobileSearchIcon = select('#doc-mobile-search');
      mobileSearchIcon.classList.toggle('mobile-search-active');
      this.leftSideBar.hide();
      this.closeRightSideBar();
      this.toggleMobileSearch(mobileSearchIcon.classList.contains('mobile-search-active'));
    });
  }

closeSearchResult() {
    select('#doc-body-cont').classList.remove('gcse-search');
    select('#doc-search-result').classList.add('doc-hide');
    select('#doc-content-search input').value = '';
    if (select('#md-content').scrollTop > 20) {
      btn.style.display = "block";
    }
  }

  toggleMobileSearch(bool) {
    select('#doc-mobile-search').classList[bool ? 'add' : 'remove']('mobile-search-active');
    select('#md-content').classList[bool ? 'add' : 'remove']('mobile-search-enabled');
    if (!select('#doc-body-cont').classList.contains('gcse-search')) {
      select('#doc-mobile-content-search').classList[bool ? 'remove' : 'add']('doc-hide');
    }
  }

  closeRightSideBar() {
    var mobileRightToc = select('.right-toc-active');
    if (mobileRightToc) {
      mobileRightToc.classList.remove('right-toc-active');
    }
    this.rightSideBar.hide();
  }

  selectedToc() {
    var path = this.getPathName();
    var toc = document.getElementById('toc');
    var selectTree = toc.querySelector(`[data-uid='${path}']`);
    var selectAcrdn = toc.querySelector(`[data='${path}']`);
    if (selectTree) {
      selectTree.classList.add('e-toc-active');
    }
    if (selectAcrdn) {
      closest(selectAcrdn, '.e-acrdn-item').classList.add('e-toc-active');
    }
  }

  rightTocSelect() {
    var rightToc = document.getElementById('doc-right-toc');
    if (!rightToc) {
      return;
    }
    var activeElem = rightToc.querySelector('.active');
    if (rightToc) {
      var ele = rightToc.querySelector(`[href="#${window.location.href.split('#')[1]}"]`);
      if (ele) {
        if (activeElem) {
          activeElem.classList.remove('active');
        }
        ele.parentElement.classList.add('active');
      }
    }
  }

  searchSelect(e) {
    if (e.itemData && e.itemData.id) {
      if (urlCheckRegex.test(e.itemData.id)) {
        window.open(e.itemData.id);
      } else {
        navToPath(e.itemData.id);
      }
    }
  }

  rightTocHighlight() {
    if (document.getElementById('doc-right-toc')) {
      var mdContent = document.getElementById('md-content');
      var rightToc = document.getElementById('doc-right-toc');
      var selctedElem = rightToc.querySelector('.select');
      var activeElement = rightToc.querySelector('.active') ? rightToc.querySelector('.active') : '';
      var headers = mdContent.querySelectorAll('h2,h3,h4,h5,h6');
      for (var hEle of headers) {
        if (this.checkVisibilty(hEle, mdContent)) {
          var headEle = rightToc.querySelector(`[href='#${hEle.id}']`);
          if (headEle) {
            if (selctedElem) {
              selctedElem.classList.remove('select');
            }
            headEle.parentNode.classList.add('select');
            if(activeElement !== ''){
              activeElement.classList.remove('active');
              }
          }
          return;
        }
      }
    }
  }

  checkVisibilty(elem, parent) {
    var pageTop = parent.scrollTop;
    var pageBottom = pageTop + parent.offsetHeight;
    var elementTop = elem.offsetTop;
    var elementBottom = elementTop + parseInt(window.getComputedStyle(elem).height);
    return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
  };

  ScrollToc() {
    setTimeout(() => {
      var selectedToc = select(`[data-uid="${this.getPathName()}"]`) ||
        select('#toc .e-acrdn-item.e-active') || select('#toc .e-acrdn-item.e-toc-active');
      if (selectedToc) {
        selectedToc.scrollIntoView();
      }
    }, 0);
  }

  feedBackUp() {
    var FeedBack = {
      URL: window.feedbackTest ? 'https://ej2.syncfusion.com/javascript/documentation/grid/getting-started/' : window.location.href,
      UUID: uuid,
      Feedback: select('#feedback-up').innerText.trim(),
      IsFeedbackProvided: false
    }
    $.ajax({
      url: " https://websiteapi.syncfusion.com/feedback/doc",
      dataType: "json",
      type: 'POST',
      crossDomain: true,
      data: FeedBack
    });  
    feedback.classList.add('doc-feedback-up');
    feedback.innerHTML = 'Thank you for your feedback!';
    var animation = new Animation({ duration: 3000, name: 'FadeOut', end: function () { select('#footer-feedback').classList.add('doc-hide') } });
    animation.animate(feedback);
  }
  scrollTopMove(){
    select('#md-content').scrollTop = 0;
  }
  resetFeedBackDown() {
    var chbxs = selectAll('#checkboxes input', feedBackDownResponse);
    for (var chbx of chbxs) {
      chbx.ej2_instances[0].checked = false;
      var id = chbx.id;
      var tArea = select('#comment' + id, this.feedBackDownResponse);
      tArea.value = '';
      tArea.classList.add('doc-hide');
      select('.error-message.' + id, feedBackDownResponse).classList.add('doc-hide');
    }
    select('.email-input', feedBackDownResponse).value = '';
    this.emailCheckBox.checked = false;
    closest(this.emailCheckBox.element, '.e-checkbox-wrapper').classList.add('doc-hide');
    select('.feed-submit').ej2_instances[0].disabled = true;
  }

  feedBackDown() {
    if (feedDlgInit) {
      closest(this.emailCheckBox.element, '.e-checkbox-wrapper').classList.add('doc-hide');
      select('.email-input').addEventListener('keyup', (e) => {
        closest(this.emailCheckBox.element, '.e-checkbox-wrapper').classList[!e.target.value ? 'add' : 'remove']('doc-hide');
      });
      feedDlgInit = !feedDlgInit
    }
    this.feedBackDialog.show();
  }

  feedBackDownCancel() {
    feedBackDownResponse.classList.add('doc-hide');
    feedback.classList.remove('doc-hide');
    this.resetFeedBackDown();
  }

  feedBackSubmit() {
    if (this.validateFeedBack()) {

      feedBackDownResponse.classList.add('doc-hide');
      select('#feedBackDlg .e-dlg-header-content').classList.add('doc-hide');
      select('#feedBackDlg .e-footer-content').classList.add('doc-hide');
      select('#feedBackDlg').classList.add('feed-thanks');
      select('#feedBackDlg .feedback-up-response').classList.remove('doc-hide');


      var animation = new Animation({
        duration: 2500, name: 'FadeOut', end: function () {
          select('#feedBackDlg').classList.add('doc-hide');
          select('#feedBackDlg').ej2_instances[0].hide();
          select('#footer-feedback').classList.add('doc-hide');
        }
      });
      animation.animate('#feedBackDlg');

      var myIp = '';
      var ipAjax = new Ajax("https://ipinfo.io/json", 'GET', true);
      ipAjax.send().then();
      ipAjax.onSuccess = (data) => {
        myIp = JSON.parse(data).ip;
        var FeedBack = {
          UUID: uuid,
          URL: window.feedbackTest ? 'https://ej2.syncfusion.com/javascript/documentation/grid/getting-started.html' : window.location.href,
          IPAddress: myIp,
          IsFeedbackProvided: true,
          Email: select('.feedback-down-response .email-input').value,
          Message: this.feedBackMessage(),
          CanContact: this.emailCheckBox.checked,
          Feedback: select('#feedback-down').innerText.trim()
        }

        console.log(JSON.stringify(FeedBack, null, 4));

        $.ajax({
          url: " https://websiteapi.syncfusion.com/feedback/doc",
          dataType: "json",
          type: 'POST',
          crossDomain: true,    
          data: FeedBack            
      });
      }
    }
  }

  feedBackMessage() {
    var feedBackMessage = "";
    var chbxs = selectAll('#checkboxes input', feedBackDownResponse);
    var countNumber = 1;
    for (var chbx of chbxs) {
      if (chbx.checked) {
        var label = chbx.ej2_instances[0].label;
        var comment = select('#comment' + chbx.id, this.feedBackDownResponse).value;
        // eslint-disable-next-line
        feedBackMessage += countNumber + ". <b>" + label + "</b><br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + comment + "<br><br>"
        countNumber++;
      }
    }
    return feedBackMessage;
  }

  validateFeedBack() {
    var validationOk = true;
    var chbxs = selectAll('#checkboxes input', feedBackDownResponse);
    for (var chx of chbxs) {
      var chbx = chx.ej2_instances[0];
      if (chbx.checked) {
        var id = chx.id;
        if (!select('#comment' + id, this.feedBackDownResponse).value) {
          select('.error-message.' + id, feedBackDownResponse).classList.remove('doc-hide');
          validationOk = false;
        }
      }
    }
    return validationOk;
  }

  floatFocus(args) {
    args.target.parentElement.classList.add('e-input-focus');
  }

  floatBlur(args) {
    args.target.parentElement.classList.remove('e-input-focus');
  }

  feedBackCheck(args) {
    var checkbox = args.event.srcElement.previousSibling;
    var id = checkbox.id;
    select('#comment' + id, feedBackDownResponse).classList[checkbox.checked ? 'remove' : 'add']('doc-hide');
    select('.error-message.' + id, feedBackDownResponse).classList.add('doc-hide');
    var checked = false;
    var chbxs = selectAll('#checkboxes input', feedBackDownResponse);
    for (var chbx of chbxs) {
      if (chbx.checked) {
        checked = true;
        break;
      }
    }
    select('.feed-submit').ej2_instances[0].disabled = !checked;
  }

  noteSupport(mdString) {
    var matchNote = mdString.match(noteCheckRegex);
    var checkRegex = /<p>(Note|Warning|Information|Error|Tips)[\s]*:.+/;
    var removeRegex = /<(|\/)p>((Note|Warning|Information|Error|Tips)[\s]*:[\s]*|)/g;
    var typeRegex = /(Note|Warning|Information|Error|Tips)[\s]*/;
    if (matchNote !== null) {
      for (var str of matchNote) {
        var content = str.match(checkRegex)[0];
        var matchContent = content.replace(removeRegex, '')
        var typeName = content.match(typeRegex)[0];
        var className = typeName.toLowerCase();
        className = className === 'information' ? (className + 's') : className;
        var note = `<p class ="${className} common-notes"><span class ="${className}-header common-notes-contents common-notes-headers">${typeName}: </span><span class = "${className}-content common-notes-contents">` + matchContent + '</span></p>';
        mdString = mdString.replace(str, note);
      }
    }
    return mdString;
  }

  /* eslint-disable */
  render() {
    const { header, breadCrumb, isReleaseNotes, title, description, platform, isRobots, headerTag, publishDate, readingTime } = this.props.pageContext;
    const postNode = this.props.data.postBySlug;
    if(noteCheckRegex.test(postNode.html)){
    postNode.html = this.noteSupport(postNode.html); 
    }
    postNode.html = postNode.html.replace(codeBlockRegex,'').replace(/sandbox=\"allow-same-origin allow-scripts allow-popups\"/g,'sandbox=\"allow-same-origin allow-scripts allow-popups allow-presentation\"');
    if (headerTag) {
      var h1 = postNode.html.match(/<h1.+<\/h1>/g) ? postNode.html.match(/<h1.+<\/h1>/g)[0] : null;
      if (h1){
      var newHeader = h1.replace(/<\/a>.+<\/h1>/g,'</a>'+headerTag+'</h1>');
      postNode.html = postNode.html.replace(h1, newHeader);
      }
      }
      var headerELement = postNode.html.match(/<h1.+<\/h1>/g) ? postNode.html.match(/<h1.+<\/h1>/g)[0] : null;
      readingTime.text = readingTime.text.replace('min', 'minutes to');
      readingTime.text = readingTime.text.indexOf('1 minutes') === 0 ? readingTime.text.replace('1 minutes', '1 minute') : readingTime.text;
      postNode.html = !isReleaseNotes && !isApi ? postNode.html.replace(headerELement, headerELement + `${postNode.html.includes('<div id="timeToRead">') ?
      '' : '\n<div id="timeToRead">' + publishDate + ' / ' + readingTime.text + '</div>'}`) : postNode.html;
    var releaseClass = "";
    if (isReleaseNotes) {
      releaseClass = " doc-release-notes"
    }
    var mdContentClass = "e-view";
    if (!header) {
      mdContentClass += " doc-no-right-toc";
    }
    var metaRobot = { name: '', content: '' }
    if (isRobots) {
      metaRobot.name = "robots";
      metaRobot.content = "nofollow";
    }
    demosLink = demosMapper[platform];
    isAspDocs = aspRegex.test(platform);
    plat = platform;
    return (
      <Layout>
        <div>
          <Helmet>
            <title>{title.replace(/Blazor \[Preview\]/, 'Blazor')}</title>
            <meta name="description" content={description.replace(/Blazor \[Preview\]/, 'Blazor')} />
            <meta name={metaRobot.name} content={metaRobot.content} />
            <script src="https://code.jquery.com/jquery-3.4.1.min.js" integrity="sha256-CSXorXvZcTkaix6Yvo6HppcZGetbYMGWSFlBw8HfCJo=" crossorigin="anonymous"></script>
            <link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet"></link>
          </Helmet>
          <div id="doc-body" className={"e-view" + releaseClass + (isApi ? ' api-docs' : '')}>
            <div hidden id="sync-analytics" data-queue={`EJ2 - ${platform === 'JavaScript (ES5)' ? 'JavaScript ES5' : platform} - Documentation`}></div>
            <HeaderContainer className="e-view">
              <SiteHeader platform={platform} />
            </HeaderContainer>
            <div id="doc-body-container" className="e-view">
              <SidebarComponent id="doc-left-sidebar" enableGestures={false} width="265px" type="Over" target="#doc-body-container" ref={Sidebar => this.leftSideBar = Sidebar}>
                <LeftPane id="doc-left-pane" className="e-view">
                  <div id="left-pane-search" className="e-view">
                    <AutoCompleteComponent id='auto-complete' ref={t => this.search = t} fields={searchFields} dataSource={searchData} placeholder="Filter by title" select={this.searchSelect.bind(this)} ></AutoCompleteComponent>
                    <div className="doc-toc-search-icon"></div>
                  </div>
                  {/* <BrowserRouter> */}
                  {/* <Switch> */}
                  <div id="doc-left-toc" className="e-view">
                    <div id="toc"></div>
                    <div className="doc-mobile-links">
                      <div className="doc-mobile-links-split">
                        <a href={demosLink} target="_blank"><div className="doc-mobile-link doc-demos-link">DEMOS</div></a>
                        <a href="https://www.syncfusion.com/support/directtrac/incidents" target="_blank"><div className="doc-mobile-link doc-support-link">SUPPORT</div></a>
                      </div>
                      <div className="doc-mobile-links-split">
                        <a href={`https://www.syncfusion.com/forums/${platform === 'Blazor'? 'blazor-components' : platformMapper[platform]}`} target="_blank"><div className="doc-mobile-link doc-forum-link">FORUM</div></a>
                        <a href={`https://www.syncfusion.com/downloads/${isAspDocs ? platformMapper[platform] : 'essential-js2'}`} target="_blank"><div className="doc-mobile-link doc-download-link">DOWNLOAD</div></a>
                      </div>
                    </div>
                  </div>
                  {/* </Switch> */}
                  {/* </BrowserRouter> */}
                </LeftPane>
              </SidebarComponent>
              <BodyContainer id="doc-body-cont" className={mdContentClass}>
                <div id="bread-crumb-data" data={breadCrumb}></div>
                <div id="doc-body-header" className="e-view">
                  <div id="doc-bread-crumb"></div>
                  <div id="doc-mobile-toc" className="doc-icons icon-toc"></div>
                  <div id="doc-mobile-search" className="doc-icons icon-search doc-hide"></div>
                  <div className="doc-search-results-header">Search results</div>
                  <div id="doc-content-search"></div>
                  </div>
                  <div id = "is-release" className="doc-hide">
                  <DropDownListComponent id="country-ddl" iconCss='filter-drop' ref={(scope) => { this.dropObj = scope; }} index={this.index} fields={this.dropField} dataSource={this.filterData} change={this.onFilterReleaseNotes} created={this.onFilterCreated}/>
                  </div>
                  <ToastComponent ref={(toast) => { this.toastObjEmail = toast; }} id='toast_custom' cssClass={'toast-firchild'} position={this.cusPosition} newestOnTop={true} width={500} height={160} timeOut={0} created={this.toastObjEmailCreate = this.toastObjEmailCreate.bind(this)} open={this.toastObj = this.toastObj.bind(this)} close={this.closetoast = this.closetoast.bind(this)} ></ToastComponent>
                <div id="doc-mobile-content-search" className="doc-hide e-view"></div>
                <div className="doc-body-content">
                  <div id="md-content" className="e-view" onScroll={this.rightTocHighlight.bind(this)}>
                  <div id="md-cnt" dangerouslySetInnerHTML={{ __html: postNode.html.replace(/{:version:}/g, config.version).replace(/('|&#39;|’){:nuget-version:}('|&#39;|’)/g, config.nugetVersion)}} />
                    <NavButtons id="nav-buttons">
                      <NavButton id="prev-button">
                        <a id="prev-link"><div className="doc-icons icon-prev_icon nav-prev-icon"></div><div className="nav-prev-text">Previous</div></a>
                      </NavButton>
                      <NavButton id="next-button">
                        <a id="next-link"><div className="doc-icons icon-next_icon nav-next-icon"></div><div className="nav-next-text">Next</div></a>
                      </NavButton>
                    </NavButtons>
                    <div id="doc-footer">
                      {isNotIE ?
                        <div id="footer-feedback">
                          <div className="feedback-ques">
                            <div className="feedback-ques-text">Is this page helpful?</div>
                            <div id="feedback-down" className="feedback" onClick={this.feedBackDown.bind(this)}>
                              <div className="feedback-down-icon"></div>
                              <div className="feedback-down-text">No</div>
                            </div>
                            <div id="feedback-up" className="feedback" onClick={this.feedBackUp.bind(this)}>
                              <div className="feedback-up-icon"></div>
                              <div className="feedback-up-text">Yes</div>
                            </div>
                          </div>
                        </div>
                        : <div id="ie"></div>}
                      <div id="footer-copyright">
                      <a id="copyright" target="_blank" href="http://www.syncfusion.com/copyright">Copyright © 2001 - <span id="copyright-year"> {new Date().getFullYear()}</span> Syncfusion Inc. All Rights Reserved</a>
                      </div>
                    </div>
                  </div>
                  <RightToc dangerouslySetInnerHTML={{ __html: header }}></RightToc>
                </div>
                <SidebarComponent id="doc-mobile-right-toc" className="doc-hide doc-no-width" isOpen={false} enableGestures={false} width="260px" type="Over" position="Right" ref={Sidebar => this.rightSideBar = Sidebar}>
                  <RightToc dangerouslySetInnerHTML={{ __html: header }}></RightToc>
                </SidebarComponent>
                <div id="doc-search-result" className="doc-hide"></div>
              </BodyContainer>
            </div>
            <div id="doc-overlay" className="e-view">
              <div className="doc-loading">
                <svg className="circular" height="40" width="40">
                  <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="6" strokeMiterlimit="10"></circle>
                </svg>
              </div>
            </div>
            {isNotIE ?
              <DialogComponent id="feedBackDlg" buttons={[{
                click: () => {
                  this.feedBackSubmit();
                },
                buttonModel: { content: 'SUBMIT', isPrimary: true, cssClass: 'e-primary feed-submit', disabled: true }
              },
              {
                click: () => {
                  this.feedBackDialog.hide();
                },
                buttonModel: { content: 'CANCEL', cssClass: 'e-primary feed-cancel' }
              }]} visible={false} isModal={true} showCloseIcon={true} header='HELP US TO IMPROVE THIS PAGE' width='50%'
                close={this.resetFeedBackDown.bind(this)} ref={dialog => this.feedBackDialog = dialog} target='#doc-body'>
                <div className="feedback-down-response">
                  <div id="checkboxes" className="multiselect">

                    <CheckBoxComponent id="one" label="Correct inaccurate or outdated content" change={this.feedBackCheck.bind(this)} />
                    <br />
                    <textarea id="commentone" className="form-control message doc-hide" rows="3" placeholder="Please specify what content needs correction..."></textarea>
                    <div className="error-message doc-hide one">Please provide additional information</div>
                    <br />

                    <CheckBoxComponent id="two" label="Improve illustrations or images" change={this.feedBackCheck.bind(this)} />
                    <br />
                    <textarea id="commenttwo" className="form-control message doc-hide" rows="3" placeholder="Please specify which images can be improved..."></textarea>
                    <div className="error-message doc-hide two">Please provide additional information</div>
                    <br />

                    <CheckBoxComponent id="three" label="Fix typos or broken links" change={this.feedBackCheck.bind(this)} />
                    <br />
                    <textarea id="commentthree" className="form-control message doc-hide" rows="3" placeholder="Please specify what needs to be fixed..."></textarea>
                    <div className="error-message doc-hide three">Please provide additional information</div>
                    <br />

                    <CheckBoxComponent id="four" label="Add more information" change={this.feedBackCheck.bind(this)} />
                    <br />
                    <textarea id="commentfour" className="form-control message doc-hide" rows="3" placeholder="Please specify what information should be added..."></textarea>
                    <div className="error-message doc-hide four">Please provide additional information</div>
                    <br />

                    <CheckBoxComponent id="five" label="Correct inaccurate or outdated code samples" change={this.feedBackCheck.bind(this)} />
                    <br />
                    <textarea id="commentfive" className="form-control message doc-hide" rows="3" placeholder="Please specify what needs correction..."></textarea>
                    <div className="error-message doc-hide five">Please provide additional information</div>
                    <br />

                    <CheckBoxComponent id="six" label="Other" change={this.feedBackCheck.bind(this)} />
                    <br />
                    <textarea id="commentsix" className="form-control message doc-hide" rows="3" placeholder="Please enter feedback on topics not previously listed..."></textarea>
                    <div className="error-message doc-hide six">Please provide additional information</div>

                  </div>


                  <input className="e-input email-input" onFocus={this.floatFocus} onBlur={this.floatBlur} type="email" placeholder="Email (optional)" />

                  <CheckBoxComponent ref={c => this.emailCheckBox = c} id="emailcheckbox" label='I agree to the creation of a Syncfusion account in my name and to be contacted regarding this message. No further action will be taken. Please see our <a href="https://www.syncfusion.com/privacy" target="_blank"> Privacy policy.</a>' />

                  <div id="email-error-message" className="error-message doc-hide"></div>
                </div>
                <div className="feedback-up-response doc-hide">Thank you for your feedback and comments.We will rectify this as soon as possible!</div>
              </DialogComponent>
              : <div class="ie"></div>}
          </div>
        </div>
      </Layout>
    );
  }
  
  shouldComponentUpdate() {
    // console.log(Testing);
    return false;
  }
}

function ESTTimeOffset() {
  var jan = new Date(today.getFullYear(), 0, 1);
  var jul = new Date(today.getFullYear(), 6, 1);
  return (Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) <= today.getTimezoneOffset() ? -4 : -5) * 3600000;
}
// create cookie method
function createCookie(cookieName, cookieValue) {
  var d = new Date();
  if (cookieName != '_pageCount') {
    d.setMonth(d.getMonth() + 24);
    var expires = "expires=" + d.toUTCString();
  }
  document.cookie = cookieName + "=" + cookieValue + "; " + expires + "domain=.syncfusion.com;path=/";
}
//getcookie method
function getCookie(cookieName) {
  var name = cookieName + "=";
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    while (cookie.charAt(0) == ' ')
      cookie = cookie.substring(1);
    if (cookie.indexOf(name) == 0)
      return cookie.substring(name.length, cookie.length);
  }
  return "";
}

function nodeSelected(args) {
  if (!args.node.querySelector('.e-icons')) {
    var path = args.nodeData.id;
    if (urlCheckRegex.test(path)){
      window.open(path, '_blank');
    }
    else if (path.indexOf('/api/') !== -1) {
      var refPath = window.location.origin + prefix + path;
      window.open(refPath, '_blank');
    } else {
      navToPath(path);
    }
  }
}

function navToPath(navPath) {
  select('#doc-mobile-right-toc').classList.add('doc-hide');
  // var refPath = window.location.origin + prefix + navPath;
  // window.location.href = refPath;
  if(window.location.search && plat === 'React' && window.location.search.indexOf('type=tsx') !== -1){
    navPath = navPath + window.location.search.replace(/(\?|\&)no-cache=1/, '');
  }
  navigate(navPath);
}

Array.prototype.searchArray = function (array) {
  for (var i = 0; i < this.length; i++)
    if (this[i].indexOf(array) == 0)
      return i;
  return -1;
};

function expand(e) {
  var ele = e.element.querySelector('.toc-tree');
  if (e.name === 'expanding' && ele && ele.childElementCount === 0) {
    var data = tData;
    var tree = new TreeView({
      fields: { dataSource: data[ele.id], id: 'id', text: 'name', child: 'child' },
      nodeSelected: nodeSelected
    });
    tree.appendTo(ele);
    ele.addEventListener('mouseover', onhover);
  }
}

//Treeview multi line hover work around
function onhover(event) {
    setHeight(event.target);
}

function setHeight(element) {
  if (element.classList.contains("e-treeview")) {
    element = element.querySelector(".e-node-focus").querySelector(".e-fullrow");
  }
  else if (element.classList.contains("e-list-parent")) {
    element = element.querySelector(".e-fullrow");
  }
  else if (element.classList.value != ("e-fullrow") && element.closest(".e-list-item")) {
    element = element.closest(".e-list-item").querySelector(".e-fullrow");
  }
  if (element.nextElementSibling)
    element.style.height = element.nextElementSibling.offsetHeight + "px";
}

function accClick(e) {
  var srcElem = e.originalEvent.srcElement;
  var isIcon = srcElem.classList.contains('e-icons');
  if (isApi && !isIcon && (srcElem.classList.contains('e-acrdn-header') || srcElem.classList.contains('e-acrdn-header-content'))) {
    var accItem = closest(srcElem, '.e-acrdn-item');
    var accIndElem = select('.toc-tree', accItem);
    if (accIndElem) {
      //API Index Selection
      var pathId = '/' + accIndElem.id;
      navToPath((ignoreApiSelect.indexOf(accIndElem.id) !== -1) ? (routes[routes.searchArray(pathId)]) : pathId);
    }
  } else {
    var ele = srcElem.id === 'acc-path' ? srcElem : srcElem.querySelector('#acc-path');
    if (e.name === 'clicked' && ele) {
      var aPath = ele.getAttribute('data');
      if (ele.classList.contains('doc-ref')) {
        if (isAspDocs && aPath === '/api') {
          window.open(aspApiMapper[plat], '_blank');
        } else {
          var refPath = window.location.origin + prefix + aPath;
          window.open(refPath, '_blank');
        }
      } else if (aPath) {
        navToPath(aPath);
      }
    }
  }
}
function renderToc(clearSelect) {
  let acc = new Accordion({
    expandMode: 'Single',
    expanding: expand,
    clicked: accClick,
    items: clearSelect ? window.toc.accData : aData,
    animation: { expand: { effect: 'SlideDown', duration: 0, easing: 'linear' }, collapse: { effect: 'SlideUp', duration: 400, easing: 'linear' } }
  });
  acc.appendTo('#toc');
}

function renderTab() {
  var tabs = document.getElementsByClassName('doc-tab');
  if (tabs.length) {
    for (var i = 0; i < tabs.length; i++) {
      let tab = new Tab({
        created: function () {
          var previewHeader = this.element.querySelectorAll('.e-tab-text span')[0];
          if (previewHeader.getAttribute('data-active') === 'true') {
            this.select(1);
          }
          createInnerTab(this.element);
        },
        selecting: tabSelecting,
        selected: function (args) {
          var previewContent = this.element.getElementsByClassName('e-content')[0].children[1];
          if (args.selectedIndex === 1 && !previewContent.getElementsByTagName('iframe').length) {
            var spanElement = args.selectedItem.querySelector('.e-tab-text span');

            // get iframe height
            var frameHeight = spanElement.getAttribute('data-height');
            var iframeHeight = frameHeight ? 'style="height:' + frameHeight + '"' : '';

            // create iframe for current source
            var frameSrc = spanElement.getAttribute('data-sample');
            var iframe = '<iframe class="doc-sample-frame" src="' + frameSrc + '"' + iframeHeight + '></iframe>';
            // append iframe in preview tab
            previewContent.innerHTML = iframe;
          }
        }
      });
      tab.appendTo(tabs[i]);
    }
  } else {
    createInnerTab(document);
  }

}

function createInnerTab(element) {
  var innerTabs = element.getElementsByClassName('doc-inner-tab');
  for (var i = 0; i < innerTabs.length; i++) {
    let innerTab = new Tab({
      selecting: tabSelecting,
      created: function (e) {
        var jsxFile = innerTabs[i].querySelectorAll('[data-language="jsx"]')[0];
        if ((plat === 'React' )&& jsxFile) {
          var tbitems = this.tbItem;
          for (var k = 0, len = tbitems.length; k < len; k++) {
            var item = tbitems[k];
            var file = (window.location.search === '?type=tsx') ? '.jsx' : '.tsx';
            if (item.textContent.indexOf(file) !== -1) {
              this.hideTab(k);
            }
          }
        }
      }
    });
    innerTab.appendTo(innerTabs[i]);
  }
}
function tabSelecting(e) {
  if (e.isSwiped) {
    e.cancel = true;
  }
}

function gcseCallback() {
  // if (document.readyState !== 'complete') {
  //   return google.setOnLoadCallback(gcseCallback, true);
  // }
  setInt = setInterval(() => {
    var searchInput = select('#gsc-i-id1');
    if (searchInput) {
      searchInput.placeholder = 'Search by content';
      var gscSearchButton = select('button.gsc-search-button');
      var svgButton = select('svg', gscSearchButton);
      if (svgButton) {
        detach(svgButton);
      }
      var docSearchIcon = createElement('div', { id: 'doc-content-search-icon' });
      gscSearchButton.appendChild(docSearchIcon);
      gscSearchButton.addEventListener('click', () => {
        var searchInputEle = select('#doc-content-search input') || select('#doc-mobile-content-search input');
        if (searchInputEle.value && gcseInit) {
          gcseSearch();
        }
      })
      var searchInputEle = select('#doc-content-search input') || select('#doc-mobile-content-search input');
      searchInputEle.addEventListener('keyup', (e) => {
        if (e.keyCode === 13 && e.srcElement.value && gcseInit) {
          gcseSearch();
        }
      });
      clearInterval(setInt);
    }
  }, 100);
};

function createCustomSearch(gcsecx) {
  if (!gcsecx.length) {
    return '';
  }

  var searchBoxDiv = select(isMobile ? '#doc-mobile-content-search' : '#doc-content-search');
  var searchResultDiv = select('#doc-search-result');

  searchBoxDiv.innerHTML = '<gcse:searchbox enableAutoComplete="true"></gcse:searchbox>';
  searchResultDiv.innerHTML = '<gcse:searchresults></gcse:searchresults>';
  // if (isMobile) {
  //   select('#doc-mobile-content-search').innerHTML = select('#doc-content-search').innerHTML;
  //   select('#doc-content-search').innerHTML = '';
  // }
  if (searchBoxDiv.childNodes[0].tagName === 'GCSE:SEARCHBOX' && searchResultDiv.childNodes[0].tagName === 'GCSE:SEARCHRESULTS') {
    window.__gcse = {
      callback: gcseCallback
    };
    (function () {
      var gcse = document.createElement('script');
      gcse.type = 'text/javascript';
      gcse.async = true;
      gcse.src = 'https://cse.google.com/cse.js?cx=' + gcsecx;
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(gcse, s);
    })();
  }
}

export function urlCheck(path) {
  return urlCheckRegex.test(path);
}
const RightToc = styled.div`
`

const NavButtons = styled.div`
`

const NavButton = styled.div`
`

const BodyContainer = styled.div`
  overflow: auto;
  overflow-x: hidden;
  justify-self: center;
  width: 100%;
  padding: ${props => props.theme.sitePadding};
  @media screen and (max-width: 600px) {
    order: 2;
  }
  
  & > div {
    max-width: ${props => props.theme.contentWidthLaptop};
    margin: auto;
  }
  
  & > h1 {
    color: ${props => props.theme.accentDark};
  }
`

const HeaderContainer = styled.div`
  height: 60px;
  width: 100%;
  box-shadow: 0 8px 11px -6px rgba(0, 0, 0, 0.12);
  z-index: 1001;
  opacity: 100;
`

const LeftPane = styled.div`
  overflow: auto;
  overflow-x: hidden;
  border-right: 1px solid #ddd;
  background: #FAFAFA;
  @media screen and (max-width: 600px) {
    overflow: inherit;
  }
`

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query LayoutBySlug($slug: String!) {
    allPostTitles: allMarkdownRemark{
        edges {
          node {
            fields {
              slug
              gcse
            }
          }
        }
      }
      postBySlug: markdownRemark(fields: { slug: { eq: $slug } }) {
        html
        timeToRead
        excerpt
        fields {
          slug
          gcse
        }
      } 
  }
`;
